import { Button, Paper, Typography } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import toast from 'react-hot-toast';
import ReactSelect from 'react-select';
import accountService from '../../services/AccountService';
import adminSetupService from '../../services/SetupService';
import taxCodeService from '../../services/TaxCodeService';

const NewItemDefaultAccounts = () => {
  const [accountOptions, setAccountOptions] = useState([]);
  const [incomeAccount, setIncomeAccount] = useState(null);
  const [expenseAccount, setExpenseAccount] = useState(null);
  const [loading, setLoading] = useState(false);
  const [saving, setSaving] = useState(false);

  const [taxCodeOptions, setTaxCodeOptions] = useState([]);
  const [taxCodeRef, setTaxCodeRef] = useState(null);

  useEffect(() => {
    const fetchAccountsAndSetup = async () => {
      setLoading(true);
      try {
        // eslint-disable-next-line no-undef
        const [accountsResponse, taxCodeResponse, setupResponse] = await Promise.all([
          accountService.getAccountsFromQbo(),
          taxCodeService.getTaxCodeFromQBO(),
          adminSetupService.getAdminSetup()
        ]);
        const accounts = accountsResponse?.data?.data?.QueryResponse?.Account || [];
        const options = accounts
          .filter((account) => account.Active !== false)
          .map((account) => ({
            value: String(account.Id),
            name: account.FullyQualifiedName
          }));
        const setup = setupResponse?.data?.data?.[0];
        const defaults = setup?.newItemDefaultAccounts;
        const taxCodes = taxCodeResponse?.data?.data?.QueryResponse?.TaxCode || [];
        const taxOptions = taxCodes
          .filter((taxCode) => taxCode.Active !== false)
          .map((taxCode) => ({
            value: String(taxCode.Id),
            name: taxCode.Name
          }));

        setAccountOptions(options);
        setTaxCodeOptions(taxOptions);
        setIncomeAccount(defaults?.incomeAccount || null);
        setExpenseAccount(defaults?.expenseAccount || null);
        setTaxCodeRef(setup?.newItemDefaultTaxCode || null);
      } catch (error) {
        toast.error(error?.response?.data?.message || error?.message || 'Could not fetch QBO account defaults');
      } finally {
        setLoading(false);
      }
    };

    fetchAccountsAndSetup();
  }, []);

  const handleSave = async () => {
    if (!incomeAccount || !expenseAccount || !taxCodeRef) {
      toast.error('Income account, expense account and tax code are required');
      return;
    }

    setSaving(true);
    try {
      // eslint-disable-next-line no-undef
      await Promise.all([
        adminSetupService.updateNewItemDefaultAccounts({
          incomeAccount,
          expenseAccount
        }),
        adminSetupService.updateNewItemDefaultTaxCode({ taxCodeRef })
      ]);
      toast.success('Successfully saved new item default accounts and tax code');
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message || 'Could not save QBO account defaults');
    } finally {
      setSaving(false);
    }
  };

  const selectProps = {
    options: accountOptions,
    getOptionLabel: (option) => option.name,
    getOptionValue: (option) => option.value,
    isLoading: loading,
    isClearable: true,
    className: 'basic-single',
    classNamePrefix: 'select',
    // eslint-disable-next-line no-undef
    menuPortalTarget: document.body
  };

  const taxCodeSelectProps = {
    ...selectProps,
    options: taxCodeOptions
  };

  return (
    <div style={{ marginBottom: '3rem' }}>
      <Paper style={{ padding: '1rem', display: 'flex', flexDirection: 'column', gap: '1rem' }}>
        <h3 style={{ margin: 0 }}>New items default account and tax code</h3>

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
          <div style={{ flex: '1 1 250px', minWidth: 0 }}>
            <Typography style={{ marginBottom: '0.5rem', fontWeight: 500 }}>Income account</Typography>
            <ReactSelect {...selectProps} value={incomeAccount} onChange={setIncomeAccount} />
          </div>

          <div style={{ flex: '1 1 250px', minWidth: 0 }}>
            <Typography style={{ marginBottom: '0.5rem', fontWeight: 500 }}>Expense account</Typography>
            <ReactSelect {...selectProps} value={expenseAccount} onChange={setExpenseAccount} />
          </div>
        </div>

        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '1rem' }}>
          <div style={{ flex: '1 1 250px', minWidth: 0 }}>
            <Typography style={{ marginBottom: '0.5rem', fontWeight: 500 }}>TaxCode</Typography>
            <ReactSelect {...taxCodeSelectProps} value={taxCodeRef} onChange={setTaxCodeRef} />
          </div>
        </div>

        <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
          <Button onClick={handleSave} color="primary" variant="contained" disabled={loading || saving}>
            Save
          </Button>
        </div>
      </Paper>
    </div>
  );
};

export default NewItemDefaultAccounts;
